import {FC, ReactNode} from 'react'

import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

import {Text, TextVariant} from '../content/Text'

type FormErrorMessageProps = {
  message: string | ReactNode
  bulletPoints?: string[]
  dataTest?: string
  marginBottom?: string
}

export const FormErrorMessage: FC<FormErrorMessageProps> = ({
  message,
  bulletPoints,
  dataTest,
  marginBottom,
}) => {
  const {t} = useTranslation()
  const textColor = theme.palette.red[700]

  return (
    <>
      <div className="error-message">
        <Text variant={TextVariant.text14} color={textColor} dataTest={dataTest}>
          {typeof message === 'string' ? t(message) : message}
        </Text>
        {bulletPoints && (
          <ul className="list">
            {bulletPoints.map((item) => (
              <li key={item} className="item">
                <Text variant={TextVariant.text14} color={textColor}>
                  {item}
                </Text>
              </li>
            ))}
          </ul>
        )}
      </div>

      <style jsx>{`
        .error-message {
          margin-top: ${theme.spacing[1]};
          padding: ${theme.spacing[1.5]} ${theme.spacing[2]};
          background-color: ${theme.palette.error.light};
          border-radius: 5px;
          width: 100%;
          text-align: left;
          ${marginBottom ? `margin-bottom: ${marginBottom}` : ''};
        }
        .list {
          list-style-type: disc;
          margin-left: ${theme.spacing[4]};
          margin-top: ${theme.spacing[1]};
          color: ${textColor};
        }
        .item + .item {
          margin-top: ${theme.spacing[0.5]};
        }
      `}</style>
      <style jsx global>{`
        .error-message + .input,
        .error-message + .textarea,
        .error-message + label .checkbox .mark {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.red[700]} !important;
        }
        .error-message + .input:focus,
        .error-message + .textarea:focus {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.error.main},
            0px 0px 0px 2px ${theme.palette.red[200]} !important;
        }
        .error-message + .dropzone .box path,
        .error-message + .box path {
          stroke: ${theme.palette.error.main};
        }
      `}</style>
    </>
  )
}
